export default __webpack_public_path__ + "static/FSK-ef36f9fa016e91760a49c38f32ad5161.webp";